import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import RecordsSection from "@/components/RecordsSection";
import GangView from "@/components/GangView";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { registerColumns, registerDefault } from "@/lib/entities";
import { BookUser } from "lucide-react";

export default function Verbrecherregister() {
  const [gangNames, setGangNames] = useState([]);

  const loadGangs = useCallback(async () => {
    try {
      const { data } = await api.get("/gangregister");
      setGangNames(data.map((g) => g.name));
    } catch (e) {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    loadGangs();
  }, [loadGangs]);

  const personFields = [
    { name: "name", label: "Name", type: "text", required: true },
    { name: "agv", label: "AGV (Gang)", type: "select", options: gangNames, clearable: true },
    { name: "agv_unklar", label: "AGV unklar (zeigt „AGV-Unklar“ vor dem Gangnamen)", type: "checkbox" },
    { name: "telefonnummer", label: "Telefonnummer", type: "text" },
    { name: "perso_akte", label: "Perso-Akte (Link)", type: "text", placeholder: "https://…", required: true },
    { name: "schnatter", label: "Schnatter (Link)", type: "text", placeholder: "https://…" },
    { name: "arbeitet_bei", label: "Arbeitet bei", type: "text" },
  ];

  return (
    <div>
      <PageHeader
        eyebrow="SADCR · Datenbank"
        title="Verbrecherregister"
        description="Personen- und Gangdaten. Werden in der Parole automatisch übernommen."
        icon={BookUser}
      />
      <div className="p-8">
        <Tabs defaultValue="personen">
          <TabsList className="bg-[#0C0E12] border border-zinc-800 rounded-sm p-1 h-auto gap-1">
            <TabsTrigger value="personen" data-testid="reg-tab-personen" className="rounded-sm data-[state=active]:bg-primary data-[state=active]:text-white text-zinc-400 text-xs uppercase tracking-wide font-medium px-4 py-2">
              Personen
            </TabsTrigger>
            <TabsTrigger value="gangs" data-testid="reg-tab-gangs" className="rounded-sm data-[state=active]:bg-primary data-[state=active]:text-white text-zinc-400 text-xs uppercase tracking-wide font-medium px-4 py-2">
              Gangregister
            </TabsTrigger>
          </TabsList>

          <TabsContent value="personen" className="mt-6">
            <RecordsSection
              endpoint="/verbrecherregister"
              columns={registerColumns}
              fields={personFields}
              makeDefault={registerDefault()}
              createLabel="Person hinzufügen"
              emptyLabel="Keine Personen im Register"
              testidPrefix="register"
              showArchive={false}
            />
          </TabsContent>

          <TabsContent value="gangs" className="mt-6">
            <GangView onChange={loadGangs} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
